import type { EvaluationDraftBody } from "@/hooks/queries/evaluation-draft-types";
import type { EvaluationDraftData } from "@/hooks/queries/evaluation-types";
import { persistableTasks } from "./TaskSelectionStep";

/**
 * Project the store's draft down to the save-draft wire body. The backend schema is
 * `extra="forbid"`, so this allow-lists the known wire fields rather than spreading the
 * draft wholesale (a stray UI-only key would 422). `current_step` IS sent so resume
 * re-opens the exact step the clinician left.
 *
 * Partial task cards (a category chosen but no specific task yet) are dropped via
 * `persistableTasks` — the store keeps them so the grid can show the in-progress card
 * (AC 2), but `SelectedTaskDraft.task_code` is `min_length=1` server-side, so an empty
 * `task_code` would 422 the WHOLE full-replace save (Story 6.4 AC 6, gh-450 data-loss).
 */
export function toEvaluationDraftBody(draft: EvaluationDraftData): EvaluationDraftBody {
  return {
    evaluation_date: draft.evaluation_date ?? null,
    context: draft.context ?? null,
    notes: draft.notes ?? null,
    diagnosis: draft.diagnosis ?? null,
    tasks: persistableTasks(draft.tasks ?? []),
    scores: draft.scores ?? {},
    current_step: draft.current_step ?? null,
  };
}
